// Angular imports
import { Component, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// 3rd party imports
import { RecaptchaComponent } from 'ng-recaptcha-2';

// CC-Common imports
import { MessageBoxComponent } from '@therealmanage/ciranet-ui-common';

// Service imports
import { EnvironmentConfigService } from '../_services/environment-config.service';
import { ServerErrorService } from '../_services/shared-services/server-error.service';

@Component({
  selector: `app-recaptcha-base-component`,
  template: ``,
  standalone: false
})
export abstract class RecaptchaBaseComponent {
  @ViewChild('reCaptcha', { static: false }) reCaptcha: RecaptchaComponent;
  @ViewChild('messageBox', { static: false }) messageBox: MessageBoxComponent;

  recaptchaSiteKey = this.envConfig.reCaptchaSiteKey;
  recaptchaToken = '';
  recaptchaErrorMessage = '';

  validationErrorMessage =
    'Re-captcha verification expired. Please check the checkbox again.';

  constructor(
    protected readonly errorService: ServerErrorService,
    protected readonly envConfig: EnvironmentConfigService
  ) {}

  onRecaptchaResolved(token: string): void {
    this.recaptchaToken = token;
    this.recaptchaErrorMessage = '';
  }

  onRecaptchaErrored(): void {
    this.resetRecaptcha();
    this.recaptchaErrorMessage =
      'reCAPTCHA verification failed. Please try the challenge again.';
  }

  isValidRecaptcha(): boolean {
    return !!this.recaptchaToken && !!this.recaptchaToken.trim().length;
  }

  resetRecaptcha(): void {
    this.recaptchaToken = '';
    if (this.reCaptcha) {
      this.reCaptcha.reset();
    }
  }

  processApiError(error: HttpErrorResponse): void {
    const apiError = error.error;
    if (
      apiError &&
      apiError.message &&
      apiError.message.indexOf('captcha') !== -1
    ) {
      this.messageBox.showErrorMessage(
        'Invalid Token',
        this.validationErrorMessage
      );
    } else {
      this.errorService.displayError(error);
    }
  }
}
